import styled from 'styled-components';

export const StyledOfferSection = styled.section`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0 0 50px 0;
    padding: 0 15px;
    text-align: center;

    & h2 {
        margin-bottom: 10px;
    }

    & p {
        width: 80%;
        text-align: center;
    }

    & footer {
        font-size: 16px;
        font-weight: 400;
        line-height: 20.4px;
    }

    @media screen and (min-width: 577px) {
        margin: 0 0 80px 0;
        max-width: 1340px;

        & h2 {
            margin-bottom: 20px;
        }
    }
`;
